import { useEffect, useRef, DependencyList, EffectCallback } from 'react';

/**
 * Same functionality as useEffect except it does not run on
 * the first/initial render
 */
function useDidMountEffect(func: EffectCallback, deps: DependencyList) {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
}

export default useDidMountEffect;
